<section id="index-about-section" class="index-about">
    <div class="container">
        <div class="about-grid">
            <div class="about-offerings">
                <div class="about-services">
                    <div class="service-card">
                        <div class="service-label">Edge & reliability</div>
                        <h4>We harden every touchpoint</h4>
                        <ul>
                            <li>Global CDN, load balancing, and autoscaling tuned to your audience curves.</li>
                            <li>TLS, DNS, and routing ownership with continuous verification.</li>
                            <li>24/7 incident response with preset playbooks and stakeholder updates.</li>
                        </ul>
                    </div>
                    <div class="service-card">
                        <div class="service-label">Growth operations</div>
                        <h4>Keep momentum after launch day</h4>
                        <ul>
                            <li>Experiment pipelines that ship features behind feature-flag safeties.</li>
                            <li>CRM + marketing automation that reflects live product usage.</li>
                            <li>Dedicated PM support to prioritize improvements from signal to sprint.</li>
                        </ul>
                    </div>
                    <div class="service-card">
                        <div class="service-label">Customer pulse board</div>
                        <h4>Readiness dashboard</h4>
                        <div class="d-grid gap-3">
                            <div class="portal-metric">
                                <span class="metric-label">Deployments cleared</span>
                                <span class="metric-value">5</span>
                                <span class="metric-sub">Next window: 22:00 EST</span>
                            </div>
                            <div class="portal-metric">
                                <span class="metric-label">Customer escalations</span>
                                <span class="metric-value text-warning">0</span>
                                <span class="metric-sub">Ops review in 18 minutes</span>
                            </div>
                            <div class="portal-card-footer">
                                <div class="portal-footer-item">
                                    <span class="footer-label">SLO coverage</span>
                                    <span class="footer-value">99.98%</span>
                                </div>
                                <div class="portal-footer-item">
                                    <span class="footer-label">CRM sync</span>
                                    <span class="footer-value">On schedule</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="service-card">
                        <div class="service-label">Monthly Earnings Board</div>
                        <h4>MTD Revenue</h4>
                        <div class="d-grid gap-3">
                            <div class="portal-metric">
                                <span class="metric-label">Monthly expenditures</span>
                                <span class="metric-value text-danger">($2,491.97)</span>
                                <span class="metric-sub"><fa-icon [icon]="faArrowDown"></fa-icon> 12% from last month</span>
                            </div>
                             <div class="portal-metric">
                                <span class="metric-label">Monthly revenue</span>
                                <span class="metric-value text-success">$10,531.35</span>
                                <span class="metric-sub"><fa-icon [icon]="faArrowUp"></fa-icon> 12% from last month</span>
                            </div>
                            <div class="portal-card-footer">
                                <div class="portal-footer-item">
                                    <span class="footer-label">Profit</span>
                                    <span class="footer-value text-success">$8,039.38 USD</span>
                                </div>
                                <div class="portal-footer-item">
                                    <span class="footer-label">Budget Adherence</span>
                                    <span class="footer-value text-success">~94.55%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <article class="about-story">
                <div class="about-pill">
                    <span class="dot"></span>
                    <span>Customer-first promise & execution</span>
                </div>
                <h2 class="text-white">We'll put the <span class="text-primary">rev</span> in <span class="text-primary">rev</span>enue.</h2>
                <p class="about-lead">
                    Powell Industries embeds alongside your team to plan launches, automate releases, tame infrastructure,
                    and translate customer signals into confident decisions. You stay focused on experiments and growth while we
                    keep every system resilient, observable, and ready for whatever comes next.
                </p>

                <div class="about-highlights">
                    <div class="highlight">
                        <h3>Launch orchestration</h3>
                        <p>Coordinated rollouts with live rehearsal plans, rollback guardrails, and post-launch tuning.</p>
                    </div>
                    <div class="highlight">
                        <h3>Embedded SRE pods</h3>
                        <p>Hands-on engineers owning uptime, TLS, DNS, and observability so your roadmap never stalls.</p>
                    </div>
                    <div class="highlight">
                        <h3>Customer signal loops</h3>
                        <p>We wire up CRM, telemetry, and analytics to surface what customers really feel in real time.</p>
                    </div>
                    <div class="highlight">
                        <h3>Executive clarity</h3>
                        <p>Actionable reporting packaged for stakeholders that care about revenue, not runbooks.</p>
                    </div>
                </div>
            </article>
        </div>
    </div>
</section>
